import React, { useState } from "react";
import {
  DialogContent,
  IconButton,
  Grid,
  Dialog,
  DialogActions,
  Button,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import api from "../../components/common/APIValues";
import axios from "axios";
import CommonFunc from '../../components/common/CommonFunc';

const useStyles = makeStyles((theme) => ({
  customButtonFocus: {
    borderRadius: "8px",
    color: "white",
    backgroundColor: "#c2272d",
    "&:hover": {
      backgroundColor: "#c2272d",
    },
    "&:disabled": {
      backgroundColor: "#c2272d",
      color: "white",
    },
    fontFamily: "poppins",
    fontWeight: 700,
    textTransform: "none",
  },
  customButtonError: {
    borderRadius: "8px",
    color: "#c2272d",
    backgroundColor: "#f9f9f9",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
    "&:disabled": {
      backgroundColor: "#e0e0e0",
      color: "#c2272d",
    },
    fontFamily: "poppins",
    fontWeight: 700,
    textTransform: "none",
  },
}));

export default function UploadFile(props) {
  const matches = useMediaQuery("(min-width:600px)");
  const [fileName, setFileName] = useState(null);
  const [fileBase64String, setFileBase64String] = useState(null);
  const [fileNameErr, setFileNameErr] = useState("");
  const classes = useStyles();

  const saveChanges = () => {
    if (fileName && !fileNameErr) {
      props.handleFileSave(fileName, fileBase64String, "");
      setFileName(null);
      setFileBase64String(null);
      
    //   const origin = window.location.origin.replace('www.', '').replace('https://', '').replace('http://', '');
    //   let rowData = {
    //     DirName: "community/" + props.type + "/" + props.groupName,
    //     FileName: fileName,
    //     OriginName: origin,
    //     FileBase64String: fileBase64String,
    //   };

    //   axios({
    //     method: "post",
    //     url: api.partialURL + "UploadFileS3/UploadFile",
    //     data: JSON.stringify(rowData),
    //     headers: { "Content-Type": "application/json" },
    //     mode: "cors",
    //   })
    //     .then((res) => {
    //       if (res) {
    //         if (res.data.imageUrl !== "") {
    //           setFileName(null);
    //           setFileBase64String(null);
    //           props.handleFileSave(props.type, res.data.imageUrl);
    //         } else {
    //           setFileNameErr(res.data.errorMessage);
    //         }
    //       }
    //     })
    //     .catch(function (response) {
    //       setFileNameErr(response);
    //     });
    // } else {
    //   if (!fileName) {
    //     setFileNameErr("Please upload image file");
    //   }
    }
  };

  const handleModalClose = () => {
    setFileNameErr("");
    setFileName(null);
    setFileBase64String(null);
    props.handleModalClose();
  };

  const onFileUploadChange = (event) => {
    var file = event.target.files[0];
    if (file) {
      if (!file.name.match(/\.(jpg|jpeg|png|gif|pdf)$/)) {
        setFileNameErr("Image format is not valid.");
      } else {
        setFileName(file.name);
        setFileNameErr("");

        var blob = file.slice();
        var reader = new FileReader();

        reader.onloadend = function (evt) {
            if (evt.target.readyState === FileReader.DONE) {
                var cont = evt.target.result
                var base64String = CommonFunc.getB64Str(cont);                
                setFileName(file.name);
                setFileBase64String(base64String);
            }
        }.bind(this);

        reader.readAsArrayBuffer(blob);
      }
    } else {
      setFileName(null);
      setFileBase64String(null);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        open={props.show}
        onClose={handleModalClose}
        disableBackdropClick
      >
        <DialogContent style={{ backgroundColor: "#f6f7f2" }}>
          <Grid container spacing={0}>
            <Grid item xs={matches ? 11 : 9}></Grid>
            <Grid item xs={matches ? 1 : 3}>
              <IconButton
                style={{ float: "right", marginTop: "-20px" }}
                onClick={handleModalClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <label htmlFor="assignment_file">
            <input
              style={{ display: "none" }}
              id="assignment_file"
              name="assignment_file"
              type="file"
              accept="image/png, image/jpeg, image/jpg, image/gif, application/pdf"
              onChange={(e) => {
                onFileUploadChange(e);
              }}
            />
            <Button
              className={classes.customButtonError}
              variant="contained"
              component="span"
              size="small"
            >
              Choose File
            </Button>
          </label>
          <label style={{ marginLeft: 10 }}>{fileName}</label>
          <div style={{ fontSize: 12, marginTop: 10 }}>
            <b>Formats allowed:</b> jpg | jpeg | png | gif | pdf
          </div>
        </DialogContent>
        <DialogActions style={{ backgroundColor: "#f6f7f2" }}>
          {fileNameErr.length > 0 && (
            <span className="error">{fileNameErr}</span>
          )}
          <Button
            onClick={saveChanges}
            color="primary"
            className={classes.customButtonFocus}
            size="small"
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
